import { render, staticRenderFns } from "./ResumenProductos.vue?vue&type=template&id=450b94f9&scoped=true"
import script from "./ResumenProductos.vue?vue&type=script&lang=js"
export * from "./ResumenProductos.vue?vue&type=script&lang=js"
import style0 from "./ResumenProductos.vue?vue&type=style&index=0&id=450b94f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450b94f9",
  null
  
)

export default component.exports